// Frontend permission map — kept in sync with backend PERMISSIONS in server.py
// iter178 — Feature flags (UI Shutter) desteği eklendi
export const PERMISSIONS = {
  admin: ["*"],
  muhasebe: [
    "customers:*", "suppliers:*", "sales:*", "purchases:*", "payments:write",
    "quotes:read", "orders:read", "stock:read", "reports:read",
    "hr:read", "note_templates:read",
    "products:read", "variants:read",
  ],
  satis: [
    "customers:*", "sales:*", "quotes:*", "orders:*", "ecommerce:*",
    "payments:write", "stock:read", "reports:read",
    "hr:read", "note_templates:*",
    "products:read", "products:write", "variants:read", "variants:write",
  ],
  depo: [
    "stock:*", "orders:read", "orders:write", "purchases:read",
    "customers:read", "suppliers:read", "reports:read",
    "products:read", "products:write", "variants:read", "variants:write",
    "inventory:*",
  ],
  user: [],
};

export const ROLE_LABELS = {
  admin: "Yönetici",
  muhasebe: "Muhasebe",
  satis: "Satış",
  depo: "Depo",
  user: "Yetkisiz",
};

export function can(user, action) {
  if (!user) return false;
  const perms = user.permissions || PERMISSIONS[user.role] || [];
  if (perms.includes("*") || perms.includes(action)) return true;
  const module = action.split(":")[0];
  return perms.includes(`${module}:*`);
}

// iter178 F5 — UI Shutter: hassas görüntü alanlarını yetkiye bağlar
export function hasFeature(user, featureKey) {
  if (!user) return false;
  // Süper yönetici tüm feature'ları görür
  const perms = user.permissions || [];
  if (perms.includes("*")) return true;
  const list = user.features || [];
  return list.includes(featureKey);
}

// iter178 F4 — "İşlem Yap ama Görme": read yoksa pick yeterli mi?
export function canPick(user, module) {
  if (!user) return false;
  const perms = user.permissions || [];
  if (perms.includes("*") || perms.includes(`${module}:*`)) return true;
  return perms.includes(`${module}:read`) || perms.includes(`${module}:pick`);
}
